/**
* DevExpress Dashboard (_dashboard.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { LayoutOptions } from '../layout/layout-options';
import { DashboardTitle } from '../title';
import { dashboardTitleSerializationsInfo } from './_title';
export let currencyCultureName = { propertyName: 'currencyCultureName', modelName: '@CurrencyCulture' };
export let dashboardTitle = { propertyName: 'title', modelName: 'Title', displayName: 'DashboardStringId.Title', type: DashboardTitle, info: dashboardTitleSerializationsInfo };
export let items = { propertyName: 'items', modelName: 'Items', displayName: 'DashboardWebStringId.Dashboard.Items', array: true };
export let parameters = { propertyName: 'parameters', modelName: 'Parameters', displayName: 'DashboardWebStringId.DashboardParameters', array: true };
export let colorScheme = { propertyName: 'colorScheme', modelName: 'ColorScheme', displayName: 'DashboardWebStringId.DashboardMenuColorScheme', array: true };
export let groups = { propertyName: 'groups', modelName: 'Groups', displayName: 'DashboardWebStringId.Dashboard.Groups', array: true };
export let dataSources = { propertyName: 'dataSources', modelName: 'DataSources', displayName: 'DashboardWebStringId.DashboardMenuDataSources', array: true };
export let layout = { propertyName: 'layout', modelName: 'LayoutTree' };
export let layoutOptions = { propertyName: 'layoutOptions', modelName: 'LayoutOptions', type: LayoutOptions };
export let dashboardSerializationsInfo = [dashboardTitle, items, groups, dataSources, currencyCultureName, layout, layoutOptions, parameters, colorScheme];
